import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Loader2, Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "@/pages/admin/AdminLayout";
import { fmtDate, fmtEuro, STATUS_STYLES, useApi } from "@/lib/api";
import { generateQuotePdf } from "@/lib/quotePdf";

export default function Quotes() {
  const api = useApi();
  const [quotes, setQuotes] = useState(null);
  useEffect(() => {
    api("get", "/admin/quotes").then(setQuotes);
  }, [api]);

  const remove = async (id) => {
    if (!window.confirm("Eliminare questo preventivo?")) return;
    await api("delete", `/admin/quotes/${id}`);
    setQuotes((qs) => qs.filter((q) => q.id !== id));
    toast.success("Preventivo eliminato");
  };

  return (
    <div data-testid="admin-quotes-page">
      <PageHeader title="Preventivi" subtitle="Crea, modifica e scarica i preventivi in PDF">
        <Link to="/admin/preventivi/nuovo" data-testid="admin-create-quote-button" className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-emerald-500 hover:text-slate-900">
          <Plus className="h-4 w-4" /> Nuovo preventivo
        </Link>
      </PageHeader>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        {!quotes ? <div className="p-10"><Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" /></div> : (
          <table data-testid="admin-quotes-table" className="w-full min-w-[720px] text-left text-sm">
            <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
              <tr>{["Numero", "Cliente", "Data", "Totale", "Stato", ""].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr>
            </thead>
            <tbody>
              {quotes.map((q) => (
                <tr key={q.id} data-testid={`quote-row-${q.id}`} className="border-b border-slate-100 last:border-0">
                  <td className="px-4 py-3 font-mono text-xs">{q.number}</td>
                  <td className="px-4 py-3 font-medium">{q.customer_name}</td>
                  <td className="px-4 py-3 text-slate-500">{fmtDate(q.created_at)}</td>
                  <td className="px-4 py-3 font-semibold">{fmtEuro(q.total)}</td>
                  <td className="px-4 py-3"><span className={`rounded-full border px-2.5 py-1 text-xs font-medium ${STATUS_STYLES[q.status]}`}>{q.status}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex justify-end gap-1">
                      <Link to={`/admin/preventivi/${q.id}`} data-testid={`quote-edit-${q.id}`} className="rounded-lg p-2 hover:bg-slate-100" aria-label="Modifica"><Pencil className="h-4 w-4" /></Link>
                      <button data-testid={`quote-pdf-${q.id}`} onClick={() => generateQuotePdf(q)} className="rounded-lg p-2 hover:bg-slate-100" aria-label="Scarica PDF"><Download className="h-4 w-4" /></button>
                      <button data-testid={`quote-delete-${q.id}`} onClick={() => remove(q.id)} className="rounded-lg p-2 text-rose-600 hover:bg-rose-50" aria-label="Elimina"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {quotes.length === 0 && <tr><td colSpan={6} data-testid="quotes-empty" className="px-4 py-12 text-center text-slate-500">Nessun preventivo. Creane uno nuovo o partendo da un lead.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
